angular.module('SpidApp')

.factory('Cash',
		['_',
function (_) {
	var Cash = {
		deno: function (bills, coins) {
			return (
				'bills=' + _.map(bills, function (bill) {
					return bill.value + ':' + bill.quantity
				}).join(';') +
				'|' +
				'coins=' + _.map(coins, function (coin) {
					return coin.value + ':' + coin.quantity
				}).join(';')
			)
		},
		reno: function(str) {
			if (!str) {
				throw 'Cash::reno() - Missing parameters'
			}

			str = str.replace('bills=', '')
			str = str.replace('coins=', '')

			var split = str.split('|')
			var billsStr = split[0]
			var coinsStr = split[1]

			var _reno = function (duet) {
				var split = duet.split(':')
				return { value: +split[0], quantity: +split[1] }
			}

			return {
				bills: billsStr !== '' ? _.map(billsStr.split(';'), _reno) : [],
				coins: coinsStr !== '' ? _.map(coinsStr.split(';'), _reno) : []
			}
		},
		cumulate: function (coins, bills) {
			if (!coins || !bills) {
				throw 'Cash::cumulate() - Missing parameters'
			}

			var set = coins.concat(bills)
			return +_.reduce(set, function (memo, cash) {
				return memo + cash.value * cash.quantity
			}, 0).toFixed(2)
		}
	}

	return Cash
}])